import { useRef } from 'react'

import { useInfiniteScroll, useNetwork } from 'ahooks'
import { Toast } from 'antd-mobile'

import { isSuccess } from '@/axios'
import { ISearchNovelResponse, searchNovel } from '@/api'
import { handleSearchKeywordTrack } from '@/utils'

const PAGE_SIZE = 20

export const useSearchDiscover = (target: string) => {
  const searchValRef = useRef('')
  const { online } = useNetwork()
  const abortControllerRef = useRef<AbortController | null>(null)

  const handleGetList = async (nowData: ISearchNovelResponse | undefined, currentPage: number) => {
    const params = {
      page: currentPage,
      size: PAGE_SIZE,
      keyword: searchValRef.current,
    }

    if (nowData && !online) {
      Toast.show({
        position: 'top',
        content: 'Network Error',
      })
      return Promise.reject()
    }
    abortControllerRef.current = new AbortController()
    const resp = await searchNovel(params, abortControllerRef.current.signal)

    if (resp && isSuccess(resp)) {
      if (currentPage === 1) {
        handleSearchKeywordTrack(searchValRef.current, resp.data.count, 'discover')
      }
      return resp.data
    }

    return {
      list: [],
      count: 0,
    }
  }

  const { data, mutate, loadMore, loading, loadingMore, reload, noMore } = useInfiniteScroll<ISearchNovelResponse>(
    (nowData) => {
      let currentPage = 1
      if (nowData) {
        currentPage = nowData.list.length / PAGE_SIZE + 1
      }

      return handleGetList(nowData, currentPage)
    },
    {
      manual: true,
      isNoMore: (nowData) => {
        if (nowData) {
          return nowData.list.length === nowData.count
        }

        return false
      },
    },
  )

  const handleSearchData = (search: string) => {
    searchValRef.current = search
    document.getElementById(target)?.scrollTo(0, 0) // 重置滚动高度
    mutate({ list: [], count: 0 })
    reload()
  }

  return {
    data,
    mutate,
    loadMore,
    loading,
    loadingMore,
    reload,
    noMore,
    handleSearchData,
    abortControllerRef,
  }
}
